import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#0F172A] py-16 px-4 border-t border-white/5" data-id="element-129">
      <div className="max-w-4xl mx-auto text-center" data-id="element-130">
        <div className="text-white text-3xl font-black tracking-widest mb-6 flex items-center justify-center gap-3 drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]" data-id="element-131">
          <span className="text-4xl" data-id="element-132">🍎</span> EduLabs™ Matemática
        </div>

        <p className="text-white/90 text-lg leading-relaxed mb-10 max-w-xl mx-auto font-medium" data-id="element-133">
          Recursos didácticos de excelencia para docentes que cambian vidas.
        </p>

        <div className="flex items-center justify-center gap-6 text-sm text-white/80 mb-10" data-id="element-134">
          <span className="flex items-center gap-2" data-id="element-135">
            <span data-id="element-136">📧</span> soporte.edulabs@gmail.com
          </span>
        </div>

        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8 w-full max-w-lg mx-auto" data-id="element-137" />

        <p className="text-white/60 text-xs tracking-wider" data-id="element-138">
          © EDULABS™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}